






























import Vue from 'vue'
import EmojiText from '@/components/EmojiText'
import { TweetCSS } from '@/types/layouts'
import './Tweet.scss'


type CSS = CSSStyleDeclaration

export default Vue.extend({
  name: 'Tweet',
  props: {
    width: {
      type: Number,
      required: false
    },
    height: {
      type: Number,
      required: false
    },
    css: {
      type: Object,
      required: true
    },
    tweet: {
      type: Object,
      required: true
    }
  },
  data: () => ({
    defaultcss: new TweetCSS(),
    font: 'Dancing Script'
  }),
  computed: {
    isPoll () {
      return this.tweet.type === 'tweetpoll'
    },
    // background
    backgroundstyle () : Partial<CSS> {
      const r : Partial<CSS> = {}
      r.backgroundColor = this.getValue('background', 'color')
      r.borderRadius = this.getPixelSize('largest', 'background', 'borderradius') + 'px'
      return r
    },
    // avatar
    avatarstyle () : Partial<CSS> {
      const r : Partial<CSS> = {}
      r.direction = this.getValue('avatar', 'visible') ? 'block' : 'none'
      r.left = this.getPixelSize('width', 'avatar', 'left') + 'px'
      r.top = this.getPixelSize('height', 'avatar', 'top') + 'px'
      r.width = this.getPixelSize('largest', 'avatar', 'width') + 'px'
      r.height = this.getPixelSize('largest', 'avatar', 'width') + 'px'
      r.borderRadius =  this.getPixelSize('largest', 'avatar', 'width') / 2 + 'px'
      return r
    },
    profileimage () {
      if (this.tweet && this.tweet.data && this.tweet.data.user && this.tweet.data.user.profile_image_url) {
        return this.tweet.data.user.profile_image_url
      }
      return ''
    },
    // username
    username () : string {
      if (this.tweet && this.tweet.data && this.tweet.data.user && this.tweet.data.user.name && this.tweet.data.user.screen_name) {
        const username = this.tweet.data.user.name + ' (@' + this.tweet.data.user.screen_name + ')'
        return this.removeEmojis(username)
      }
      return ''
    },
    usernameStyle () : Partial<CSS> {
      const r : Partial<CSS> = {}
      r.left = this.getPixelSize('width', 'username', 'left') + 'px'
      r.top = this.getPixelSize('height', 'username', 'top') + 'px'
      r.fontSize = this.getPixelSize('largest', 'username', 'fontsize') / 3 + 'px'
      r.fontFamily =  this.getFontFamily('username', 'font')
      r.color = this.getValue('username', 'color')
      return r
    },
    // question
    question () {
      if (this.tweet && this.tweet && this.tweet.question) {
        return this.tweet.question
      }
      return ''
    },
    questionStyle () : Partial<CSS> {
      const r : Partial<CSS> = {}
      r.left = this.getPixelSize('width', 'question', 'left') + 'px'
      r.top =  this.getPixelSize('height', 'question', 'top') + 'px',
      r.fontSize = this.getPixelSize('largest', 'question', 'fontsize') / 3 + 'px'
      r.fontFamily = this.getFontFamily('question', 'font')
      r.color = this.getValue('question', 'color')
      return r
    },
    // handler
    handlestyle () : Partial<CSS> {
      const r: Partial<CSS> = {}
      r.display = this.getValue('handle', 'visible') ? 'block' : 'none'
      r.height =  this.getPixelSize('largest', 'handle', 'width') + 'px'
      r.left = this.getPixelSize('width', 'handle', 'left') + 'px'
      r.top = this.getPixelSize('height', 'handle', 'top') + 'px'
      r.fontSize = this.getPixelSize('largest', 'handle', 'fontsize') / 3 + 'px'
      r.fontFamily = this.getFontFamily('handle', 'font')
      r.color = this.getValue('handle', 'color')
      return r
    },
    handlenamestyle () : Partial<CSS> {
      const r : Partial<CSS> = {}
      let top = this.getPixelSize('largest', 'handle', 'width') - this.getPixelSize('largest', 'handle', 'fontsize') / 3
      top = top / 2
      r.marginLeft =  this.getPixelSize('largest', 'handle', 'width') * 1.2 + 'px'
      r.marginTop = `${top}px`
      return r
    },
    twitterref () {
      if (this.tweet.type === 'tweet' && this.tweet.data && this.tweet.data.twitterref) {
        return this.tweet.data.twitterref
      } else if (this.tweet.type === 'tweetpoll' && this.tweet.url) {
        return '@' + this.tweet.url.split('/')[3]
      }
      return null
    },
    // tweet text
    tweettext () : string {
      if (!this.tweet || !this.tweet.data || !this.tweet.data.text) return ''
      const text = this.tweet.data.selectedText ? this.tweet.data.selectedText : this.tweet.data.text
      const maxLength = 280
      if (text.length <= maxLength) return text
      else return text.substring(0, maxLength) + '...'
    },
    textstyle () : Partial<CSS> {
      const r : Partial<CSS> = {}
      r.left = this.getPixelSize('width', 'tweet', 'left') + 'px'
      r.width = this.getPixelSize('width', 'tweet', 'width') + 'px'
      r.top = this.getPixelSize('height', 'tweet', 'top') + 'px'
      r.fontSize = this.getPixelSize('largest', 'tweet', 'fontsize') / 3 + 'px'
      r.fontFamily = this.getFontFamily('tweet', 'font')
      r.color = this.getValue('tweet', 'color')
      r.direction = 'ltr'
      if (!this.getValue('tweet', 'ltr')) {
        r.direction = 'rtl'
        r.textAlign = 'right'
      }
      return r
    },
    answers () {
      return this.tweet.answers ? this.tweet.answers : []
    }
  },
  methods: {
    getFontFamily (component: string, tag: string): string {
      const font = this.getValue(component, tag)
      if (font) return font + ', Work Sans, Helvetica, Arial, sans-serif'
      return 'Work Sans, Helvetica, Arial, sans-serif'
    },
    getValue (component: string, tag: string) : any {
      //Set to fallback default value
      let value = this.defaultcss[component]?.[tag]
      if (value === undefined) {
        console.error(`Default CSS for ${component} / ${tag} not existing`)
        value = 0
      }
      //Set to given value if it exists
      if (this.css?.[component]?.[tag] !== undefined) {
        value = this.css[component][tag]
      }
      return value
    },
    getNumberValue (component:string, tag: string) : number {
      const v = this.getValue(component, tag)
      if (typeof(v) ==='number'){
        return v
      } else{
        throw new Error(`v=${v} is not a number`)
      }
    },
    getPixelSize (direction: string, component:string , tag:string) : number {
      const value = this.getNumberValue(component, tag)
      if (direction === 'largest') return Math.max(this.height, this.width) * value / 100
      if (direction === 'width') return this.width * value / 100
      if (direction === 'height') return this.height * value / 100
      return 0
    },
    removeEmojis (text) {
      const regex = /(?:[\u2700-\u27bf]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff]|[\u0023-\u0039]\ufe0f?\u20e3|\u3299|\u3297|\u303d|\u3030|\u24c2|\ud83c[\udd70-\udd71]|\ud83c[\udd7e-\udd7f]|\ud83c\udd8e|\ud83c[\udd91-\udd9a]|\ud83c[\udde6-\uddff]|[\ud83c[\ude01\uddff]|\ud83c[\ude01-\ude02]|\ud83c\ude1a|\ud83c\ude2f|[\ud83c[\ude32\ude02]|\ud83c\ude1a|\ud83c\ude2f|\ud83c[\ude32-\ude3a]|[\ud83c[\ude50\ude3a]|\ud83c[\ude50-\ude51]|\u203c|\u2049|[\u25aa-\u25ab]|\u25b6|\u25c0|[\u25fb-\u25fe]|\u00a9|\u00ae|\u2122|\u2139|\ud83c\udc04|[\u2600-\u26FF]|\u2b05|\u2b06|\u2b07|\u2b1b|\u2b1c|\u2b50|\u2b55|\u231a|\u231b|\u2328|\u23cf|[\u23e9-\u23f3]|[\u23f8-\u23fa]|\ud83c\udccf|\u2934|\u2935|[\u2190-\u21ff])/g
      return text.replace(regex, '')
    },
    barstyle (answerindex: number) : { width: string, color: string, 'background-color': string } {
      const colors = ['#397BCE', '#03AEEF', '#D69D36', '#4D4D4D', '#EEEEEE']
      return {
        'background-color': colors[answerindex],
        width: this.answers[answerindex] ? this.answers[answerindex].percent + '%' : '0%',
        color: 'rgba(0, 0, 0, 0)'
      }
    }
  },
  components: {
    EmojiText
  }
})
